import { useMutation, useQueryClient } from "@tanstack/react-query";
import postClientOfferingInterest from "../requests/postClientOfferingInterest";
import { clientMarketplaceOfferingKeyMaker } from "./useClientMarketplaceOffering";
import { clientMarketplaceOfferingKeyMaker as clientMarketplaceOfferingKeyMakerV2 } from "./useClientMarketplaceOfferingV2";
export default function useExpressClientOfferingInterest(config) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async ({ offeringId, offeringInterest }) => {
            if (config === null) {
                throw new Error("No auth config");
            }
            return postClientOfferingInterest(offeringId, offeringInterest, config);
        },
        onSuccess: (_, { offeringId }) => {
            // NOTE: invalidate modified offering v1
            queryClient.invalidateQueries({
                queryKey: clientMarketplaceOfferingKeyMaker(offeringId),
            });
            // NOTE: invalidate modified offering v2
            queryClient.invalidateQueries({
                queryKey: clientMarketplaceOfferingKeyMakerV2(offeringId),
            });
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=useExpressClientOfferingInterest.js.map